(function () {
  'use strict';

  if (window.__lgCartSyncInitialized) return;
  window.__lgCartSyncInitialized = true;

  var originalFetch = window.fetch.bind(window);
  var originalXhrOpen = XMLHttpRequest.prototype.open;
  var refreshTimer = null;
  var refreshPromise = null;
  var openAfterRefresh = false;

  function getUrl(input) {
    if (typeof input === 'string') return input;
    if (input && typeof input.url === 'string') return input.url;
    return '';
  }

  function isCartAddRequest(input) {
    var url = getUrl(input);

    try {
      url = new URL(url, window.location.origin);
      return url.origin === window.location.origin && /\/cart\/add(?:\.js)?\/?$/.test(url.pathname);
    } catch (error) {
      return /\/cart\/add(?:\.js)?(?:[?#]|$)/.test(url);
    }
  }

  function sectionUrl(sectionId) {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';
    var separator = root.indexOf('?') === -1 ? '?' : '&';

    return root + separator + 'section_id=' + encodeURIComponent(sectionId);
  }

  function parseSection(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function replaceSection(current, replacement) {
    if (!current || !replacement) return null;
    var imported = document.importNode(replacement, true);
    current.replaceWith(imported);
    return imported;
  }

  function updateCountFallback(itemCount) {
    document.querySelectorAll('.thb-item-count').forEach(function (count) {
      count.textContent = itemCount > 99 ? '*' : itemCount;
    });
  }

  function announceCartUpdate(cart) {
    var detail = { cart: cart };
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: detail }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: detail }));
  }

  function openCartDrawer(drawer) {
    if (!drawer) return;

    document.body.classList.add('open-cc');
    drawer.classList.add('active');

    if (typeof window.dispatchCustomEvent === 'function') {
      window.dispatchCustomEvent('cart-drawer:open');
    } else {
      document.dispatchEvent(new CustomEvent('cart-drawer:open'));
    }
  }

  function refreshCart(openDrawer) {
    openAfterRefresh = openAfterRefresh || openDrawer !== false;

    if (refreshPromise) return refreshPromise;

    refreshPromise = Promise.all([
      originalFetch(sectionUrl('cart-drawer'), {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Unable to refresh cart drawer');
        return response.text();
      }),
      originalFetch(sectionUrl('cart-bubble'), {
        credentials: 'same-origin',
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Unable to refresh cart bubble');
        return response.text();
      }),
      originalFetch('/cart.js', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json' }
      }).then(function (response) {
        if (!response.ok) throw new Error('Unable to refresh cart data');
        return response.json();
      })
    ]).then(function (results) {
      var drawerDocument = parseSection(results[0]);
      var bubbleDocument = parseSection(results[1]);
      var cart = results[2];
      var drawer = replaceSection(
        document.getElementById('Cart-Drawer'),
        drawerDocument.getElementById('Cart-Drawer')
      );
      var bubble = replaceSection(
        document.getElementById('cart-drawer-toggle'),
        bubbleDocument.getElementById('cart-drawer-toggle')
      );

      if (!bubble) updateCountFallback(cart.item_count);

      if (drawer && typeof CartDrawer !== 'undefined') {
        new CartDrawer();
      }

      announceCartUpdate(cart);

      if (openAfterRefresh) openCartDrawer(drawer);
    }).catch(function (error) {
      console.warn('[Land Guard cart sync]', error);
    }).finally(function () {
      refreshPromise = null;
      openAfterRefresh = false;
    });

    return refreshPromise;
  }

  function scheduleRefresh(openDrawer) {
    openAfterRefresh = openAfterRefresh || openDrawer !== false;
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(function () {
      refreshTimer = null;
      refreshCart(openAfterRefresh);
    }, 80);
  }

  window.fetch = function () {
    var args = Array.prototype.slice.call(arguments);
    var cartAddRequest = isCartAddRequest(args[0]);

    return originalFetch.apply(window, args).then(function (response) {
      if (cartAddRequest && response.ok) scheduleRefresh(true);
      return response;
    });
  };

  XMLHttpRequest.prototype.open = function (method, url) {
    this.__lgCartAddRequest = isCartAddRequest(url);

    if (this.__lgCartAddRequest) {
      this.addEventListener('load', function () {
        if (this.status >= 200 && this.status < 300) scheduleRefresh(true);
      }, { once: true });
    }

    return originalXhrOpen.apply(this, arguments);
  };

  document.addEventListener('cart:item-added', function () {
    scheduleRefresh(true);
  });

  window.LandGuardCartSync = {
    refresh: refreshCart
  };
})();
